<template>
  <a-card :bordered='false' v-show="candidates.length > 0">
    <div v-show="!stampShowed">
      <span>
        身份证号:
        <a-input  style="width: 200px;margin-right: 20px" v-model="userName" :max-length='20'></a-input>
        真实姓名:
        <a-input style="width: 200px;margin-right: 20px" v-model="realName" :max-length='10'></a-input>
      </span>
      <span class="noPrint">
        <AppraiseSignatureButton
          v-show="needSign"
          ref="SignatureButton"
          :pdf-params="pdfParams"
          :stampShowed="stampShowed"
          :disabled="!needSign"
          @sign="sign"
          @signShow="signShow"
        ></AppraiseSignatureButton>
      </span>
    </div>
    <div id="pdfCentent" v-show='!stampShowed && !signedPdfFlag'>
      <h1 style="text-align:center">定标结果</h1>
      <h2 style="margin-top: -5px;">当前标段推荐中标候选人数：{{recommendNumber}}</h2>
      <a-table :columns="columns" :data-source="candidates" :pagination="false">
        <span slot="action" slot-scope="text, record, index">
          <a-select style='width: 200px'
                    :default-value=record.candidateOrder
                    @change="e => handleChange(e,record)" :disabled='disabled'>
          <a-select-option :value=null>
            请选择
          </a-select-option>
          <a-select-option :value=1>
            第一中标候选人
          </a-select-option>
          <a-select-option :value=2>
            第二中标候选人
          </a-select-option>
          <a-select-option :value=3>
            第三中标候选人
          </a-select-option>
        </a-select>
        </span>
      </a-table>

      <div style='margin-top: 20px;'>
        <a-form :form="form">
          <a-form-item :required="true" label="说明信息">
            <a-textarea style="height: 180px" placeholder="请输入澄清、说明、补正事项等" v-decorator="['bidContent',validatorRules.bidContent]"  :max-length='1000'/>
          </a-form-item>
        </a-form>
      </div>

      <div align="center" style='padding-top: 20px;' class="noPrint">
        <a-button type="primary" @click="submitPicthon" :disabled="disabled">
          确认中标人
        </a-button>
      </div>
    </div>
    <AppraiseSignFileShow v-show="signedPdfFlag && !stampShowed" @signedPdfIsExist='signedPdfIsExist' :sectionId='workflowInstanceId' :type='pdfParams.type' style="margin-top:10px"></AppraiseSignFileShow>

    <AppraiseSignatureComponent
      v-show="stampShowed"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    ></AppraiseSignatureComponent>
  </a-card>
</template>

<script>

import { httpAction, getAction, postAction,putAction } from '@/api/manage'
import { message } from 'ant-design-vue'
import pick from 'lodash.pick'
import AppraiseSignatureButton from '@comp/AppraiseSignatureButton'
import AppraiseSignatureComponent from "@comp/AppraiseSignatureComponent";
import ExpertStampTable from "@comp/ExpertStampTable";
import AppraiseSignFileShow from "@views/bobidappraise/modules/AppraiseSignFileShow.vue";

export default {
  name: 'AppraiseBidResult',
  components: {
    AppraiseSignatureButton,AppraiseSignatureComponent,ExpertStampTable,AppraiseSignFileShow
  },
  data() {
    return {
      disabled:true,
      form: this.$form.createForm(this),
      validatorRules:{
        bidContent:{rules: [{ required: true, message: '请输入澄清、说明、补正事项等!' },{ max: 1000, message: '长度不能超过1000', trigger: 'blur' }]},
      },
      candidates: [],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'bidderName',
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'bidderCode',
        },
        {
          title: '候选人排名',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }
      ],
      can:{},
      cans:[],
      needSign: true,
      isStamp: true,
      stampShowed:false,
      pdfParams: {
        isEditorCuring: "1",
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '',
        sectionId: '',
        type: 'AppraiseBidResult',
        typeZh: '定标结果签章',
        htmlTitle: '定标结果签章',
        fp : '2',
        signType:'1',
        userName:'',
        realName:'',
      },
      userName:'',
      realName:'',
      signedPdfFlag:true,
      recommendNumber: null,
    }
  },
  props: ['instStepId','workflowInstanceId','sectionId','bidProjectId'],
  created() {
    this.pdfParams.bidProjectId = this.bidProjectId
    this.pdfParams.sectionId = this.workflowInstanceId
    this.getCandidateInfo();
    this.getBidInfo();
    this.getRecommendNumber();
  },
  methods: {
    getBidInfo(){
      let that = this;
      getAction('/ebid-ce/boCandidate/getBidInfo/'  + this.workflowInstanceId + '/' + this.sectionId, {}).then(res => {
        if (res.success) {
          if(res.result.isFinishBid == 1){
            that.disabled = true;
            this.$nextTick(() => {
              this.form.setFieldsValue(pick({"bidContent":res.result.bidContent},'bidContent'))
            });
          }else{
            that.disabled = false;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getCandidateInfo() {
      let that = this;
      getAction('/ebid-ce/boCandidate/getBoCandidates/'  + this.workflowInstanceId, {}).then(res => {
        if (res.success) {
          if(res.result.length == 0){
            that.$message.warning("无定标候选人")
          }
          that.candidates = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleChange(value , info) {
      this.can[info.id] = value;
    },
    submitPicthon: function() {
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let model = {};
          let formData = Object.assign(model, values);
          if(!this.submitVerify()){
            return
          }
          formData.workflowInstanceId = that.workflowInstanceId;
          formData.sectionId = that.sectionId;
          formData.instStepId = that.instStepId;
          let data = {}
          data.candidates = this.cans
          data.bidContent=formData.bidContent
          data.sectionId = that.sectionId
          data.workflowInstanceId = that.workflowInstanceId
          this.$confirm({
            title: '提示',
            content: '确定提交中标人吗?',
            okText: '确定',
            /*okType: 'danger',*/
            cancelText: '取消',
            onOk() {
              postAction('/ebid-ce/boCandidate/submitPicthon',data).then((res) => {
                if (res.success) {
                  // that.$emit('getNewWfInst');
                  that.$message.success('提交成功！');
                  that.disabled = true;
                } else {
                  that.$message.error(res.message);
                }
              }).catch(() => {
                that.$message.error('当前操作失败，请重试！');
              })
            },
            onCancel() {
              console.log('Cancel');
            }
          });
        }
      });
    },
    //提交校验
    submitVerify(){
      let canCount1= 0;
      let canCount2= 0;
      let canCount3= 0;
      for (let canKey in this.can) {
        if(this.can[canKey] != null) {
          let model = {};
          model.id = canKey;
          model.candidateOrder = this.can[canKey];
          model.workflowInstanceId = this.workflowInstanceId;
          this.cans.push(model)
          if (this.can[canKey] == 1) {
            canCount1++;
          }
          if (this.can[canKey] == 2) {
            canCount2++;
          }
          if (this.can[canKey] == 3) {
            canCount3++;
          }
        }
      }
      if(canCount1 != 1 || canCount2 > 1 || canCount3 > 1 || canCount3 > canCount2) {
        this.$message.warning("请正确选择中标候选人排名后再提交！");
        this.isGroupFinishLoading = false;
        return false;
      }
      if (this.recommendNumber == null || canCount1 + canCount2 + canCount3 != this.recommendNumber){
        this.$message.warning("请正确选择中标候选人数量后再提交！");
        this.isGroupFinishLoading = false;
        return false;
      }
      return true;
    },
    sign(type) {
      if(!this.disabled){
        this.$message.error("请先确定中标人")
        return
      }
      if(this.userName == '' || this.realName == ''){
        this.$message.error("请填写信息")
        return
      }
      this.pdfParams.signType = type;
      //显示签章
      var that = this;
      this.$confirm({
        title: '提示',
        content: '您确定要进行签章操作吗？',
        onOk() {
          //设置本页面标识，用于redis key记录当前页面签章信息
          that.pdfParams.pageId = that.instStepId + "_" + "report" + "_" + new Date().getTime();
          that.pdfParams.userName = that.userName;
          that.pdfParams.realName = that.realName;
          that.$refs.stamp.checkStamp();
        },
        onCancel(){
          that.pdfParams.pageId="";
          that.pdfParams.signedPdfUrl="";
          that.stampShowed = false;
          that.$refs.stamp.pdfUrl=null;
        },
      })
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    changeIsStamp(val) {
      this.stampShowed = val;
    },
    checkStampForm(callback) {
      callback(true);
    },
    //判断签章文件是否存在
    signedPdfIsExist(value){
      this.signedPdfFlag = value
    },
    getRecommendNumber() {
      getAction('/ebid-ce/boAppraiseConfig/getRecommendNumber/' + this.workflowInstanceId , {}).then(res => {
        if (res.success) {
          this.recommendNumber = res.result;
        } else {
        }
      })
    },
  }
}
</script>

<style lang='less' scoped>
  @media print{
    .noPrint{
      display: none ;
    }
  }
</style>